PegasusTemplate.TemplatePreviewRoute = Ember.Route.extend({
  activate: function(){
    PegasusTemplate.stateMachine.transitionTo('idling');
    PegasusTemplate.set('loaded', true);
    PegasusTemplate.set('status', 'previewing');
  },
  model: function(params){
    return Em.Object.create(PegasusTemplate.IOManager.generateOutput());
  },
  setupController: function(controller, model){
    this.controllerFor('blockOperations').set('content', null);
    this.controllerFor('rowOperations').set('content', null);
    this._super(controller, model);
  },
  renderTemplate: function(){
    this.render({
      outlet: 'preview'
    });
  },
  deactivate: function(){
    this._super();

    PegasusTemplate.set('loaded', false);
  },
  actions: {
    didExitPreview: function(){
      Em.set( PegasusTemplate, 'status', 'editing' );
      this.transitionTo('template.index', this.modelFor('template'));
    },
    didSelect: function(){
      PegasusTemplate.get('externalProxy').send('didSelect');
    },
    gotoTemplate: function(){
      PegasusTemplate.set('status', 'editing');
      this.transitionTo('template', this.controllerFor('template').get('content') );
    },
    escape: function(){
      this.send('didExitPreview');
    },
    didLoadTemplate: Em.K
  }
});
